/// <reference types="./ContentPath.d.ts" />
export function contentValuePathToString(path) {
    let result = '';
    for (const segment of path) {
        if (Number.isInteger(segment)) {
            result += `[${segment}]`;
        }
        else {
            if (result.length === 0) {
                result += segment;
            }
            else {
                result += `.${segment}`;
            }
        }
    }
    return result;
}
//# sourceMappingURL=ContentPath.js.map